import { useNavigate } from 'react-router-dom'
import { AlertStatusModal } from '@/shared/components/confirmation'
import { INSTRUMENT_UNAVAILABLE } from '../lib/instrument-info-messages'

interface InstrumentPausedDialogProps {
  readonly open: boolean
  readonly message?: string
  readonly headline?: string
  readonly dialogTestId?: string
}

/** Paused instrument — modal with Back to home (matches response MS `instrument_paused`). */
export function InstrumentPausedDialog({
  open,
  message = INSTRUMENT_UNAVAILABLE,
  headline = 'Survey unavailable',
  dialogTestId = 'instrument-paused-dialog',
}: InstrumentPausedDialogProps) {
  const navigate = useNavigate()
  const goHome = () => navigate('/', { replace: true })

  return (
    <AlertStatusModal
      open={open}
      headline={headline}
      bodyLines={[message]}
      primaryLabel="Back to home"
      onPrimary={goHome}
      onClose={goHome}
      dialogTestId={dialogTestId}
      primaryTestId="instrument-paused-dialog-back-home"
    />
  )
}
